import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=6ec23c38&scoped=true&"
import script from "./CustomerService.vue?vue&type=script&lang=ts&"
export * from "./CustomerService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec23c38",
  null
  
)

export default component.exports